<template>
	<div
		:class="{ connected: $laravel.user }"
	>
		<router-view />
	</div>
</template>
<script>
</script>
